import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  Row,
  Input,
  Select,
  Space,
  Typography,
  InputNumber,
  AutoComplete,
} from "antd";
import { Content } from "antd/es/layout/layout";
import React, { useContext, useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { DATA_MASTER_DATA_TYPE, ESTATE_TYPE } from "../../../../lib/const";
import useLineOfWork from "../../../../lib/hooks/useLineOfWork";
import useMasterData from "../../../../lib/hooks/useMasterData";
import useEState from "../../../../lib/hooks/useEState";

import { routes } from "../../../../routes";
import moment from "moment";

import {
  SearchAreaUsageContext,
  initialPageValues,
  initialSearchValues,
} from "../searchContext";

const { Title } = Typography;
const { Option } = Select;
const years = moment().add(1, "years").format("YYYY");
const yearArray = [
  parseInt(years),
  parseInt(years - 1),
  parseInt(years - 2),
  parseInt(years - 3),
  parseInt(years - 4),
];
const months = [
  {
    value: 1,
    name: "ตุลาคม",
  },
  {
    value: 2,
    name: "พฤศจิกายน",
  },
  {
    value: 3,
    name: "ธันวาคม",
  },
  {
    value: 4,
    name: "มกราคม",
  },
  {
    value: 5,
    name: "กุมภาพันธ์",
  },
  {
    value: 6,
    name: "มีนาคม",
  },
  {
    value: 7,
    name: "เมษายน",
  },
  {
    value: 8,
    name: "พฤษภาคม",
  },
  {
    value: 9,
    name: "มิถุนายน",
  },
  {
    value: 10,
    name: "กรกฎาคม",
  },
  {
    value: 11,
    name: "สิงหาคม",
  },
  {
    value: 12,
    name: "กันยายน",
  },
];

const Search = ({ roleUser }) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [lineOfWork] = useLineOfWork();
  const [estateType] = useMasterData(DATA_MASTER_DATA_TYPE, ESTATE_TYPE);
  const [estates, estateList] = useEState();

  const {
    setPageValues,
    setSearch,
    searchValues,
    pageValues,
    setSearchValues,
  } = useContext(SearchAreaUsageContext);
  const [searchCollapse, setSearchCollapse] = useState(false);
  const [estateId, setEstateId] = useState("");

  const handleClearSearchForm = () => {
    form.resetFields();
    setSearchValues(initialSearchValues);
    setPageValues(initialPageValues);
    setSearch(true);
  };

  const onSearch = (values) => {
    setSearch(true);
    setSearchValues({
      yearOfBudget: values?.yearOfBudget + 543 || "",
      month: values?.month || "",
      lineOfWork: values?.lineOfWork || "",
      estateId: estateId || "",
    });
  };

  useEffect(() => {}, [form]);

  const onSelectEstateId = (value, option) => {
    setEstateId(option.estateId);
  };

  const onChangeEstateId = (value) => {
    if (value === "") {
      setEstateId("");
    }
  };

  return (
    <Content>
      <Form style={{ marginBottom: 20 }}>
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <div className="flex justify-between items-center">
              <Title level={4} style={{ marginTop: 15, color: "#6442A4" }}>
                คลังข้อมูลการใช้พื้นที่
              </Title>
              <div>
                <Space>
                  {(roleUser[0]?.isAll || roleUser[0]?.isCreate) && (
                    <Button
                      type="primary"
                      onClick={() => navigate(routes.add_customer_area_usage)}
                    >
                      <PlusOutlined /> เพิ่มข้อมูล
                    </Button>
                  )}
                </Space>
              </div>
            </div>
          </Col>
        </Row>
      </Form>
      <Form
        layout={"vertical"}
        form={form}
        style={{
          padding: 20,
          backgroundColor: "#fff",
          borderRadius: "12px",
          border: "1px solid #F2F2F2",
          boxShadow: `0px 1px 10px 0px rgba(226, 216, 246, 0.40)`,
        }}
        onFinish={(value) =>
          onSearch({
            ...value,
          })
        }
      >
        <Row gutter={[24, 16]}>
          <Col className="gutter-row" span={8}>
            <Form.Item name={"yearOfBudget"}>
              <Select
                allowClear
                style={{
                  width: "100%",
                }}
                placeholder="ปีงบประมาณ"
                maxTagCount={"responsive"}
              >
                <Option key={"all"} value={"all"}>
                  เลือกทั้งหมด
                </Option>
                {yearArray.map((item) => (
                  <Option value={parseInt(item)}>{parseInt(item) + 543}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={8}>
            <Form.Item name={"month"}>
              <Select
                allowClear
                style={{
                  width: "100%",
                }}
                placeholder="เดือน"
                maxTagCount={"responsive"}
              >
                <Option key={"all"} value={"all"}>
                  เลือกทั้งหมด
                </Option>
                {months.map((m) => (
                  <Option value={m.value}>
                    เดือน {m.value} &nbsp;&nbsp;({m.name})
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={8}>
            <Form.Item name={"lineOfWork"}>
              <Select
                allowClear
                style={{
                  width: "100%",
                }}
                placeholder="สายปฏิบัติการ"
                maxTagCount={"responsive"}
              >
                {lineOfWork &&
                  lineOfWork.map((l) => (
                    <Option value={l.lineOfWork}>{l.nameTh}</Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={8}>
            <Form.Item label="" name={"estateId"}>
              <AutoComplete
                filterOption={true}
                options={estateList}
                onChange={(e) => onChangeEstateId(e)}
                onSelect={onSelectEstateId}
              >
                <Input
                  placeholder="ชื่อนิคมอุตสาหกรรม"
                  prefix={<SearchOutlined />}
                />
              </AutoComplete>
            </Form.Item>
          </Col>

          <Col span={24} align="right">
            <Space>
              <Button onClick={handleClearSearchForm}>ล้างข้อมูล</Button>
              <Button type="primary" htmlType="submit">
                ค้นหา
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </Content>
  );
};

export default Search;
